import { Alert, Modal, Tooltip } from "antd";
import React, { useState } from "react";
import { HiEye, HiPencil } from "react-icons/hi";
import { IoTrashOutline } from "react-icons/io5";
import { ActionsKey } from "../../models/Actions";

type ActionsProps = {
  permissions: Array<ActionsKey>;
  onViewDetailClick?: () => void;
  onUpdateClick?: () => void;
  onDeleteClick?: () => void;
};

const Actions = ({
  permissions,
  onDeleteClick,
  onUpdateClick,
  onViewDetailClick,
}: ActionsProps) => {
  const [deleting, setDeleting] = useState<boolean>(false);
  return (
    <>
      {permissions.includes("read") && (
        <Tooltip title={"Détails"}>
          <div className=" cursor-pointer" onClick={onViewDetailClick}>
            <HiEye />
          </div>
        </Tooltip>
      )}
      {permissions.includes("update") && (
        <Tooltip title={"Modifier"}>
          <div className=" cursor-pointer" onClick={onUpdateClick}>
            <HiPencil />
          </div>
        </Tooltip>
      )}
      {permissions.includes("delete") && (
        <Tooltip title={"Supprimer"}>
          <div
            className=" cursor-pointer"
            onClick={() => {
              setDeleting(true);
            }}
          >
            <IoTrashOutline />
          </div>
        </Tooltip>
      )}
      <Modal
        title={"Suppression"}
        open={deleting}
        onOk={() => {
          setDeleting(false);
          if (onDeleteClick) {
            onDeleteClick();
          }
        }}
        onCancel={() => setDeleting(false)}
        okText={"Ok"}
        cancelText={"Annuler"}
      >
        <div>
          <Alert
            message={"Voulez-vous vraiment supprimer cet élément ?"}
            type="warning"
            showIcon
          />
        </div>
      </Modal>
    </>
  );
};

export default Actions;
